import { CountryCode } from "@al/base-lib";
import dayjs from "dayjs";
import JsCookie from "js-cookie";

export const DEFAULT_FORMAT_MAP: Partial<Record<CountryCode, string>> = {
  [CountryCode.DE]: "DD. MMMM YYYY HH:mm",
  [CountryCode.ES]: "DD. MMMM YYYY HH:mm",
  [CountryCode.FR]: "DD MMMM YYYY HH:mm",
  [CountryCode.IT]: "DD MMMM YYYY HH:mm",
  [CountryCode.BE]: "DD MMMM YYYY HH:mm",
  [CountryCode.PL]: "DD MMMM YYYY HH:mm",
  [CountryCode.ID]: "DD/MM/YYYY",
};

export function formatTime(time: number, format?: string) {
  if (!time) {
    throw new Error("time is required");
  }

  const countryCode = JsCookie.get("countryCode") as Partial<CountryCode>;

  format = format || DEFAULT_FORMAT_MAP[countryCode || CountryCode.ID];

  return dayjs(time).format(format);
}
